module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};
